import { createReducer } from 'redux-act';
import actions from '../actions/mrfActions';

const initialState = {
  createUpdateMrfPending: false,
  createUpdateMrfRes: null,
  createUpdateMrfError: null,

  getInterviewerListPending: false,
  getInterviewerListRes: null,
  getInterviewerListError: null,

  getMrfDataByIdPending: false,
  getMrfDataByIdRes: null,
  getMrfDataByIdError: null,

  submitDraftMrfPending: false,
  submitDraftMrfRes: null,
  submitDraftMrfError: null,

  getAllUserMrfPending: false,
  getAllUserMrfRes: null,
  getAllUserMrfError: null,

  getMrfDashboardAndHierarchyPending: false,
  getMrfDashboardAndHierarchyRes: null,
  getMrfDashboardAndHierarchyError: null,

  getMrfForApprovalDataPending: false,
  getMrfForApprovalDataRes:null,
  getMrfForApprovalDataError:null,

  approveRejectMrfPending: false,
  approveRejectMrfRes:null,
  approveRejectMrfError:null,

};

/* Create Update Mrf Reducers */
const handleCreateUpdateMrfRequest = state => {
  return {
    ...state,
    ...{
      createUpdateMrfPending: true,
      createUpdateMrfRes: null,
      createUpdateMrfError: null,
    },
  };
};
const handleCreateUpdateMrfSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createUpdateMrfPending: false,
      createUpdateMrfRes: payload,
      createUpdateMrfError: null,
    },
  };
};
const handleCreateUpdateMrfError = (state, payload) => ({
  ...state,
  ...{
    createUpdateMrfPending: false,
    createUpdateMrfRes: null,
    createUpdateMrfError: payload,
  },
});


/*  Get Interviewer List Reducers */
const handleGetInterviewerListRequest = state => {
  return {
    ...state,
    ...{
      getInterviewerListPending: true,
      getInterviewerListRes: null,
      getInterviewerListError: null,
    },
  };
};
const handleGetInterviewerListSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getInterviewerListPending: false,
      getInterviewerListRes: payload,
      getInterviewerListError: null,
    },
  };
};
const handleGetInterviewerListError = (state, payload) => ({
  ...state,
  ...{
    getInterviewerListPending: false,
    getInterviewerListRes: null,
    getInterviewerListError: payload,
  },
});

/*  Submit Draft Mrf Reducers */
const handleSubmitDraftMrfRequest = state => {
  return {
    ...state,
    ...{
      submitDraftMrfPending: true,
      submitDraftMrfRes: null,
      submitDraftMrfError: null,
    },
  };
};
const handleSubmitDraftMrfSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      submitDraftMrfPending: false,
      submitDraftMrfRes: payload,
      submitDraftMrfError: null,
    },
  };
};
const handleSubmitDraftMrfError = (state, payload) => ({
  ...state,
  ...{
    submitDraftMrfPending: false,
    submitDraftMrfRes: null,
    submitDraftMrfError: payload,
  },
});


/*  Get  Mrf Data By Id Reducers */
const handleGetMrfDataByIdRequest = state => {
  return {
    ...state,
    ...{
      getMrfDataByIdPending: true,
      getMrfDataByIdRes: null,
      getMrfDataByIdError: null,
    },
  };
};
const handleGetMrfDataByIdSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getMrfDataByIdPending: false,
      getMrfDataByIdRes: payload,
      getMrfDataByIdError: null,
    },
  };
};
const handleGetMrfDataByIdError = (state, payload) => ({
  ...state,
  ...{
    getMrfDataByIdPending: false,
    getMrfDataByIdRes: null,
    getMrfDataByIdError: payload,
  },
});

/* Get All User Mrf Reducers */
const handleGetAllUserMrfRequest = state => {
  return {
    ...state,
    ...{
      getAllUserMrfPending: true,
      getAllUserMrfRes: null,
      getAllUserMrfError: null,
    },
  };
};
const handleGetAllUserMrfSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAllUserMrfPending: false,
      getAllUserMrfRes: payload,
      getAllUserMrfError: null,
    },
  };
};
const handleGetAllUserMrfError = (state, payload) => ({
  ...state,
  ...{
    getAllUserMrfPending: false,
    getAllUserMrfRes: null,
    getAllUserMrfError: payload,
  },
});


/* Get  Mrf Dashboard And Hierarchy Reducers */
const handleGetMrfDashboardAndHierarchyRequest = state => {
  return {
    ...state,
    ...{
      getMrfDashboardAndHierarchyPending: true,
      getMrfDashboardAndHierarchyRes: null,
      getMrfDashboardAndHierarchyError: null,
    },
  };
};
const handleGetMrfDashboardAndHierarchySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getMrfDashboardAndHierarchyPending: false,
      getMrfDashboardAndHierarchyRes: payload,
      getMrfDashboardAndHierarchyError: null,
    },
  };
};
const handleGetMrfDashboardAndHierarchyError = (state, payload) => ({
  ...state,
  ...{
    getMrfDashboardAndHierarchyPending: false,
    getMrfDashboardAndHierarchyRes: null,
    getMrfDashboardAndHierarchyError: payload,
  },
});


/* Get Mrf For Approval Data Reducers */
const handleGetMrfForApprovalDataRequest = state => {
  return {
    ...state,
    ...{
      getMrfForApprovalDataPending: true,
      getMrfForApprovalDataRes: null,
      getMrfForApprovalDataError: null,
    },
  };
};
const handleGetMrfForApprovalDataSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getMrfForApprovalDataPending: false,
      getMrfForApprovalDataRes: payload,
      getMrfForApprovalDataError: null,
    },
  };
};
const handleGetMrfForApprovalDataError = (state, payload) => ({
  ...state,
  ...{
    getMrfForApprovalDataPending: false,
    getMrfForApprovalDataRes: null,
    getMrfForApprovalDataError: payload,
  },
});


/* Approve Reject Mrf Reducers */
const handleApproveRejectMrfRequest = state => {
  return {
    ...state,
    ...{
      approveRejectMrfPending: true,
      approveRejectMrfRes: null,
      approveRejectMrfError: null,
    },
  };
};
const handleApproveRejectMrfSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      approveRejectMrfPending: false,
      approveRejectMrfRes: payload,
      approveRejectMrfError: null,
    },
  };
};
const handleApproveRejectMrfError = (state, payload) => ({
  ...state,
  ...{
    approveRejectMrfPending: false,
    approveRejectMrfRes: null,
    approveRejectMrfError: payload,
  },
});




/* Clear Mrf Store */
const handleClearMrfStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CREATE_UPDATE_MRF_STORE':
      return {
        ...state,
        ...{
          createUpdateMrfPending: false,
          createUpdateMrfRes: null,
          createUpdateMrfError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_MRF_DATA_BY_ID_STORE':
      return {
        ...state,
        ...{
          getMrfDataByIdPending: false,
          getMrfDataByIdRes: null,
          getMrfDataByIdError: null,
        },
      };

    case 'HANDLE_CLEAR_SUBMIT_DRAFT_MRF_STORE':
      return {
        ...state,
        ...{
          submitDraftMrfPending: false,
          submitDraftMrfRes: null,
          submitDraftMrfError: null,
        },
      };

    case 'HANDLE_CLEAR_GET_ALL_USER_MRF_STORE':
      return {
        ...state,
        ...{
          getAllUserMrfPending: false,
          getAllUserMrfRes: null,
          getAllUserMrfError: null,
        },
      };
    case 'HANDLE_CLEAR_APPROVE_REJECT_MRF_STORE':
      return {
        ...state,
        ...{
          approveRejectMrfPending: false,
          approveRejectMrfRes: null,
          approveRejectMrfError: null,
        },
      };



    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.createUpdateMrfRequest]: handleCreateUpdateMrfRequest,
    [actions.createUpdateMrfSuccess]: handleCreateUpdateMrfSuccess,
    [actions.createUpdateMrfError]: handleCreateUpdateMrfError,

    [actions.getInterviewerListRequest]: handleGetInterviewerListRequest,
    [actions.getInterviewerListSuccess]: handleGetInterviewerListSuccess,
    [actions.getInterviewerListError]: handleGetInterviewerListError,

    [actions.getMrfDataByIdRequest]: handleGetMrfDataByIdRequest,
    [actions.getMrfDataByIdSuccess]: handleGetMrfDataByIdSuccess,
    [actions.getMrfDataByIdError]: handleGetMrfDataByIdError,


    [actions.getMrfDataByIdRequest]: handleGetMrfDataByIdRequest,
    [actions.getMrfDataByIdSuccess]: handleGetMrfDataByIdSuccess,
    [actions.getMrfDataByIdError]: handleGetMrfDataByIdError,

    [actions.submitDraftMrfRequest]: handleSubmitDraftMrfRequest,
    [actions.submitDraftMrfSuccess]: handleSubmitDraftMrfSuccess,
    [actions.submitDraftMrfError]: handleSubmitDraftMrfError,

    [actions.getAllUserMrfRequest]: handleGetAllUserMrfRequest,
    [actions.getAllUserMrfSuccess]: handleGetAllUserMrfSuccess,
    [actions.getAllUserMrfError]: handleGetAllUserMrfError,

    [actions.getMrfDashboardAndHierarchyRequest]: handleGetMrfDashboardAndHierarchyRequest,
    [actions.getMrfDashboardAndHierarchySuccess]: handleGetMrfDashboardAndHierarchySuccess,
    [actions.getMrfDashboardAndHierarchyError]: handleGetMrfDashboardAndHierarchyError,

    [actions.getMrfForApprovalDataRequest]: handleGetMrfForApprovalDataRequest,
    [actions.getMrfForApprovalDataSuccess]: handleGetMrfForApprovalDataSuccess,
    [actions.getMrfForApprovalDataError]: handleGetMrfForApprovalDataError,

    [actions.approveRejectMrfRequest]: handleApproveRejectMrfRequest,
    [actions.approveRejectMrfSuccess]: handleApproveRejectMrfSuccess,
    [actions.approveRejectMrfError]: handleApproveRejectMrfError,


    [actions.handleClearMrfStore]: handleClearMrfStore,
  },
  initialState,
);